import React, {useEffect, useState} from "react";
import CustomTable, {CustomTablePagination, useHiddenColumns} from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../actions/snackbarActions";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import axios from "axios";
import {config} from "../../Helpers/env";
import {logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {Link} from "react-router-dom";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {useDebounce} from "../Lab/useDebounce";
import {ReusableRouteTabs} from "../Utils/Dialogs/ReusableTabs";
import {history} from "../../Helpers/history";
import { formatDateTime, formatDate } from "../Utils/ConvertDate";


const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'Sl.', hidden: false},
    {id: 'anc_number', numeric: false, disablePadding: false, label: 'ANC No.', hidden: false},
    {id: 'patient_number', numeric: false, disablePadding: false, label: 'Patient No.', hidden: false},
    {id: 'patient_name', numeric: false, disablePadding: false, label: 'Patient Name', hidden: false},
    {id: 'phone_no', numeric: false, disablePadding: false, label: 'Phone', hidden: false},
    {id: 'contact_number', numeric: false, disablePadding: false, label: 'Missed Contact', hidden: false},
    {id: 'scheduled_date', numeric: false, disablePadding: false, label: 'Scheduled Date', hidden: false},
    {id: 'gestational_age', numeric: false, disablePadding: false, label: 'GA (weeks)', hidden: false},
];

const components = [
    {label: 'Active Patients',     path: '/gyn-and-obs-waiting-list'},
    {label: 'Missed Appointments', path: '/gyn-missed-appointments'},
    {label: 'Delivered Mothers',   path: '/gyn-delivered-mothers'},
    // {label: 'High Risk Mothers',   path: '/gyn-high-risk-mothers'},
];


const GynMissedAppointments = ({actions, snackbars}) => {

    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({waitingList: [], loading: 'idle', total: 0});
    const [activePage, setActivePage] = useState(1);
    const [debouncedInputValue] = useDebounce(searchValue, 500);

    const {loading, total, waitingList} = data;

    useEffect(() => {
        setData({...data, loading: 'pending'});
        axios.get(`${config.smsUrl}/obgyn/anc/defaulters/${activePage}`, {
            params: { per_page: rowsPerPage }
        }).then(res => {
            const dt = res.data || {};
            const arr = dt.defaulters || [];
            const total_count = dt.total_count || 0;
            const items = arr.map((item, index) => ({
                ...item,
                count: ((activePage - 1) * rowsPerPage) + index + 1,
                patient_name: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
                contact_number: `Contact ${item.contact_number}`,
                gestational_age: item.scheduled_gestational_age_weeks ? `${item.scheduled_gestational_age_weeks}w` : "—",
                scheduled_date: item.scheduled_date ? formatDate(item.scheduled_date) : "—",
            }));
            setData({...data, loading: 'success', waitingList: items, total: total_count});
        }).catch((err) => {
            setData({...data, loading: 'error'});
            logoutErrorMessage(err, null, actions);
        });
    }, [debouncedInputValue, activePage, rowsPerPage]);

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setActivePage(1);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const handleChangeNextPage = (value) => {
        setActivePage(value);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isRejected = loading === 'error';

    const {headCells, all_hidden, handleAllHeadCells, handleHeadCells} = useHiddenColumns(headData);

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    return (
        <div data-testid="gyn-missed-appointments" className='journals'>
            <PageTitle title='Gyn Missed Appointments'/>
            <SubHeader title="Gyn and Obs" subTitle='Missed Appointments'>
                <div className="header-icon-margin-right-zero">
                    <img src="/images/antenatal-blue.png"
                         className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>
            <div className="mui-tables">
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <CustomTable title="Missed Appointments" customPage
                             handleChangeNextPage={handleChangeNextPage}
                             headData={headCells} handler={handleSearch} records={10} total_count={total}
                             activePage={activePage} data={waitingList} colSpan={5} term={searchValue}
                             handleHeadCells={handleHeadCells} all_hidden={all_hidden}
                             handleAllHeadCells={handleAllHeadCells} pagination={pagination}>
                    <TableBody>
                        {isLoading ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">
                                <img src="/images/smsloader.gif" alt="loader"/>
                            </TableCell>
                        </TableRow> : null}
                        {isSuccess ? waitingList.length > 0 ? waitingList.slice(0, rowsPerPage)
                            .map((item, index) => (
                                <TableRow hover role="checkbox" tabIndex={-1}
                                          key={index} className='mui-table-row'>
                                    {headCells.map((head) => (
                                        <TableCell key={head.id}
                                                   hidden={head.hidden}>{item[head.id]}</TableCell>
                                    ))}
                                </TableRow>
                            )) : <TableRow>
                            <TableCell colSpan={headCells.length} align="center">No records found</TableCell>
                        </TableRow> : null}
                        {isRejected ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">The server did not return a
                                valid response</TableCell>
                        </TableRow> : null}
                    </TableBody>
                </CustomTable>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar};
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}};
}

export default connect(mapStateToProps, mapDispatchToProps)(GynMissedAppointments);